export default __webpack_public_path__ + "static/media/thumbnail.91c56783.webp";